module.exports = __webpack_public_path__ + "static/media/market_icon.bc474070.png";